var _defs, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pro_badge_svg__Group_41903",
    "data-name": "Group 41903",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.835,
    height: 18,
    viewBox: "0 0 32.835 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pro_badge_svg__linear-gradient",
    x1: 0.329,
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5632d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac30e1"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "pro_badge_svg__Rectangle_13263",
    "data-name": "Rectangle 13263",
    width: 32.835,
    height: 18,
    rx: 9,
    fill: "url(#pro_badge_svg__linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pro_badge_svg__Path_20779",
    "data-name": "Path 20779",
    d: "M1100.121,158.416a2.187,2.187,0,0,1-.932.888,3.392,3.392,0,0,1-1.6.337h-1.315v3.011H1094.7V154.81h2.887a3.488,3.488,0,0,1,1.55.315,2.2,2.2,0,0,1,.961.865,2.537,2.537,0,0,1,.022,2.427Zm-1.635-.342a1.1,1.1,0,0,0,.315-.837q0-1.146-1.281-1.146h-1.247v2.281h1.247A1.364,1.364,0,0,0,1098.486,158.074Z",
    transform: "translate(-1089.125 -149.74)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pro_badge_svg__Path_20780",
    "data-name": "Path 20780",
    d: "M1199.7,162.652l-1.73-3.056h-.742v3.056h-1.573V154.81h2.944a3.44,3.44,0,0,1,1.55.32,2.24,2.24,0,0,1,.961.865,2.363,2.363,0,0,1,.32,1.219,2.333,2.333,0,0,1-.449,1.4,2.308,2.308,0,0,1-1.337.859l1.877,3.18h-1.82Zm-2.472-4.236h1.315a1.311,1.311,0,0,0,.955-.309,1.149,1.149,0,0,0,.315-.859,1.086,1.086,0,0,0-.315-.837,1.345,1.345,0,0,0-.955-.3h-1.315Z",
    transform: "translate(-1183.244 -149.74)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "pro_badge_svg__Path_20781",
    "data-name": "Path 20781",
    d: "M1298.45,160.657a3.855,3.855,0,0,1-1.46-1.433,4.232,4.232,0,0,1,0-4.135,3.86,3.86,0,0,1,1.46-1.433,4.226,4.226,0,0,1,4.051,0,3.831,3.831,0,0,1,1.449,1.433,4.27,4.27,0,0,1,0,4.135,3.823,3.823,0,0,1-1.455,1.433,4.215,4.215,0,0,1-4.045,0Zm3.27-1.208a2.193,2.193,0,0,0,.843-.916,3.005,3.005,0,0,0,.3-1.382,2.971,2.971,0,0,0-.3-1.376,2.169,2.169,0,0,0-.843-.9,2.429,2.429,0,0,0-1.247-.315,2.458,2.458,0,0,0-1.252.315,2.153,2.153,0,0,0-.849.9,2.968,2.968,0,0,0-.3,1.376,3,3,0,0,0,.3,1.382,2.181,2.181,0,0,0,.849.916,2.429,2.429,0,0,0,1.252.32A2.4,2.4,0,0,0,1301.719,159.449Z",
    transform: "translate(-1277.223 -148.183)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProBadge);
export default __webpack_public_path__ + "static/media/pro_badge.c0dd8617c348a5a08b82031a76ea7485.svg";
export { ForwardRef as ReactComponent };